import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Download, ArrowLeft, Maximize2, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import Navbar from '../components/Navbar';
import SEO from '../components/common/SEO';

const PROSPECTUS_URL = "https://customer-assets.emergentagent.com/job_bfb4c33f-5801-45fc-b2e5-0237443f0ff9/artifacts/e2sfn8pj_UPA%20Prospectus%20web.pdf";
const PROXY_URL = `${process.env.REACT_APP_BACKEND_URL}/api/proxy-pdf?url=${encodeURIComponent(PROSPECTUS_URL)}`;

const Prospectus = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    const container = document.getElementById('prospectus-container');
    if (container) {
      if (!document.fullscreenElement) {
        container.requestFullscreen();
        setIsFullscreen(true);
      } else {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <SEO page="prospectus" />
      <Navbar />
      
      {/* Header Bar */}
      <div className="sticky top-0 z-40 bg-[#111] border-b border-[#333] px-4 py-3">
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" size="sm" className="text-white hover:text-pink-400">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </Button>
            </Link>
            <span className="text-white/50 hidden sm:inline">|</span>
            <h1 className="text-white font-semibold hidden sm:block">UPA Prospectus 2024/25</h1>
          </div>
          
          <div className="flex items-center gap-2">
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-white hover:text-pink-400 hidden sm:flex"
              onClick={toggleFullscreen}
            >
              <Maximize2 className="w-4 h-4 mr-2" />
              {isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
            </Button>
            <a 
              href={PROSPECTUS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:flex"
            >
              <Button variant="ghost" size="sm" className="text-white hover:text-pink-400">
                <ExternalLink className="w-4 h-4 mr-2" />
                Open in New Tab
              </Button>
            </a>
            <a 
              href={PROSPECTUS_URL}
              download="UPA-Prospectus-2024-25.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-[#FF007F] hover:bg-[#D6006A] text-white">
                <Download className="w-4 h-4 mr-2" />
                Download PDF
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* PDF Viewer - uses backend proxy to serve the PDF with correct headers */}
      <div id="prospectus-container" className="w-full bg-neutral-900 relative" style={{ height: 'calc(100vh - 120px)' }}>
        <embed
          src={PROXY_URL}
          type="application/pdf"
          className="w-full h-full"
          title="UPA Prospectus"
        />
      </div>

      {/* Mobile Download Prompt */}
      <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/90 to-transparent p-4 md:hidden">
        <a 
          href={PROSPECTUS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          <Button className="w-full bg-[#FF007F] hover:bg-[#D6006A] text-white py-6">
            <Download className="w-5 h-5 mr-2" />
            Download Prospectus
          </Button>
        </a>
      </div>
    </div>
  );
};

export default Prospectus;
